<template>
  <div class="card">
    <div class="card-content">
      <div class="columns">
        <div class="column is-3">
          <b-field label="Fecha">
            <b-datepicker
              placeholder="Haga click para seleccionar..."
              icon="calendar-today"
              trap-focus
              nearby-month-days
              v-model="date"
              append-to-body
              :first-day-of-week="1"
              :day-names="daysOfTheWeek"
              :month-names="monthNames"
              icon-pack="fas"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="Búsqueda">
            <b-button type="primary" @click="chargeData">Buscar</b-button>
          </b-field>
        </div>
      </div>
      <b-table
        :data="listBedHistories"
        :narrowed="true"
        :hoverable="true"
        :loading="isLoading"
        paginated
        per-page="10"
      >
        <b-table-column
          field="n_cama"
          label="N° de Cama"
          v-slot="props"
          searchable
        >
          Cama {{ props.row.bed.n_cama }}
        </b-table-column>
        <b-table-column
          field="ventilator_used"
          label="Ventilador ocupado"
          v-slot="props"
          searchable
        >
          {{
            props.row.ventilator_used == null
              ? "NO"
              : props.row.ventilator_used.toUpperCase()
          }}
        </b-table-column>
        <b-table-column
          field="covid19"
          label="COVID19"
          v-slot="props"
          searchable
        >
          {{ props.row.covid19 }}
        </b-table-column>
        <b-table-column
          field="bed.stablishment.name"
          label="Establecimiento"
          v-slot="props"
          searchable
        >
          {{ props.row.bed.stablishment.name }}
        </b-table-column>
        <b-table-column
          field="bed.subcategorization.name"
          label="Subcategorización"
          v-slot="props"
          searchable
        >
          {{ props.row.bed.subcategorization.name }}
        </b-table-column>
        <b-table-column
          field="user.completeName"
          label="Responsable"
          v-slot="props"
          searchable
        >
          {{ props.row.user.completeName }}
        </b-table-column>
        <b-table-column
          field="created_at"
          label="Ingreso"
          v-slot="props"
          searchable
        >
          {{ props.row.created_at }}
        </b-table-column>
        <b-table-column
          field="updated_at"
          label="Actualización"
          v-slot="props"
          searchable
        >
          {{ props.row.updated_at }}
        </b-table-column>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="frown-open" size="is-large"></b-icon>
              </p>
              <p>No hay camas en el listado actual</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { BedHistoryFindByUpdatedAt, BedHistoryFindByUpdatedAtAndStablishment } from "../../services/bedHistory";
import moment from "moment";
export default {
  props: ["stablishmentId"],
  data() {
    return {
      listBedHistories: [],
      isLoading: false,
      date: new Date(),
      daysOfTheWeek: ["D","L","M","M","J","V","S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      let data;
      if (!this.stablishmentId) {
        data = await BedHistoryFindByUpdatedAt(
          this.$http,
          moment(this.date).format("YYYY-MM-DD")
        );
      } else {
        data = await BedHistoryFindByUpdatedAtAndStablishment(
          this.$http,
          moment(this.date).format("YYYY-MM-DD"),
          this.stablishmentId
        );
      }
      let dataFiltered = data.filter(bed => bed.state1 != "eliminada");
      this.listBedHistories = dataFiltered.map(bedHistory => {
        return  {
          ...bedHistory,
          user: {
            ...bedHistory.user,
            completeName: `${bedHistory.user.name} ${bedHistory.user.apepat} ${bedHistory.user.apemat}`
          }
        }
      })
      this.isLoading = false;
    },
  },
};
</script>